import { render, staticRenderFns } from "./crud_PayGroup.vue?vue&type=template&id=6edca3da&scoped=true"
import script from "./crud_PayGroup.vue?vue&type=script&lang=js"
export * from "./crud_PayGroup.vue?vue&type=script&lang=js"
import style0 from "./crud_PayGroup.vue?vue&type=style&index=0&id=6edca3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edca3da",
  null
  
)

export default component.exports